import React from 'react'
import ImgBack from '../../images/back--25.webp'
import './postCardBack.scss'

const PostCardBack = () => {
  return <img className="PostCardBack" src={ImgBack} alt="Gavula Family Highlights from 2025" />
}

export default PostCardBack
